import { Component, HostBinding, Input } from '@angular/core';
import {Router} from '@angular/router';
import { RouterExtService } from '../../services/router-ext.service';
import { AppSidebarService } from '../../services/app-sidebar.service';

@Component({
  selector: 'cm-app-topbar',
  templateUrl: './app-topbar.component.html',
  styleUrls: ['./app-topbar.component.scss']
})
export class AppTopbarComponent {

  @Input()
  public pageTitle: string;
  @Input()
  public titleNext: string;

  //custom back route
  @Input()
  public backBtnRouteUrl: string;

  //router back route
  @Input()
  public routerBack: string;

  @HostBinding('class.cm-kn-topbar') public bindStyle: boolean = true;

  constructor(private service: AppSidebarService,
              private routerExt: RouterExtService,
              private router: Router) {
  }

  public showSidebar() {
    this.service.setSidebarVisible(true);
  }

  public logout() {
    // this.loginService.logout(true);
  }

  goBackRoute() {
    this.router.navigateByUrl(this.backBtnRouteUrl)
  }

  goRouterBack() {
    this.routerExt.navigateToPreviousUrl(this.routerBack);
  }

}
